import { environment } from '../../../environments/environment';
import { LogEvent } from '../enums/log-event';
import { ZoidApp } from '../interfaces/zoid-app';

export const ZOID_APPS: ZoidApp[] = [
  {
    id: '2dc3c360-04ed-4f0e-be55-4ef6b7c76f38',
    url: environment.appsUrl.reservationsManager,
    name: 'reservationsManager',
    loadOptions: {
      preload: false,
      autoClose: false,
    },
    includeInAppBar: true,
    iconUrl: 'edit_calendar',
    tooltipKey: 'TOOLTIPS.RESERVATIONS_MANAGER',
    size: {
      width: 320,
    },
    logs: {
      open: LogEvent.LIVECHAT_APP_OPEN_RESERVATIONS_MANAGER,
      close: LogEvent.LIVECHAT_APP_CLOSE_RESERVATIONS_MANAGER,
    },
  },
  {
    id: '7ecf1a74-9926-11ee-b9d1-0242ac120002',
    url: environment.appsUrl.asksuiteChronos,
    name: 'asksuiteChronos',
    loadOptions: {
      preload: false,
      autoClose: false,
    },
    iconUrl: 'history',
    includeInAppBar: true,
    tooltipKey: 'TOOLTIPS.ATTENDANCE_HISTORY',
    size: {
      width: 320,
    },
    logs: {
      open: LogEvent.LIVECHAT_APP_OPEN_CHRONOS,
      close: LogEvent.LIVECHAT_APP_CLOSE_CHRONOS,
    },
  },
  {
    id: '05018194-7ef5-4cd8-99aa-f3011393eb74',
    url: environment.appsUrl.whatsappStartConversation,
    name: 'whatsappStartConversation',
    loadOptions: {
      preload: false,
      autoClose: false,
    },
    includeInAppBar: false,
    fullScreen: true,
    logs: {
      open: LogEvent.LIVECHAT_APP_OPEN_START_CONVERSATION,
      close: LogEvent.LIVECHAT_APP_CLOSE_START_CONVERSATION,
    },
  },
  {
    id: '64c9d41e-0ca8-4af8-ab92-123576d0eb63',
    url: environment.appsUrl.tasks,
    name: 'tasks',
    loadOptions: {
      preload: false,
      autoClose: false,
    },
    iconUrl: 'library_add_check',
    includeInAppBar: true,
    tooltipKey: 'TOOLTIPS.TASKS',
    size: {
      width: 320,
    },
    logs: {
      open: LogEvent.LIVECHAT_APP_OPEN_TASKS,
      close: LogEvent.LIVECHAT_APP_CLOSE_TASKS,
    },
  },
  {
    id: 'd4a0fc3c-9c24-11ee-8c90-0242ac120002',
    url: environment.appsUrl.midas,
    name: 'asksuiteMidas',
    loadOptions: {
      preload: false,
      autoClose: true,
    },
    includeInAppBar: false,
    size: {
      width: 320,
    },
    logs: {
      open: LogEvent.LIVECHAT_APP_OPEN_MIDAS,
      close: LogEvent.LIVECHAT_APP_CLOSE_MIDAS,
    },
  },
  {
    id: '10054caf-77f9-4107-9a0b-11287f699c2a',
    url: environment.appsUrl.email,
    name: 'emailAttendanceApp',
    loadOptions: {
      preload: false,
      autoClose: false,
    },
    includeInAppBar: false,
    fullScreen: true,
    logs: {
      open: LogEvent.LIVECHAT_APP_OPEN_EMAIL,
      close: LogEvent.LIVECHAT_APP_CLOSE_EMAIL,
    },
  },
  {
    id: '926db961-1d4b-43de-9547-5202ce7ad907',
    url: environment.appsUrl.phone,
    name: 'phoneApp',
    loadOptions: {
      preload: false,
      autoClose: false,
    },
    includeInAppBar: false,
    fullScreen: false,
    iconUrl: '/assets/icons/phone/phone-enabled.svg',
    tooltipKey: 'Phone',
    size: {
      width: 320,
    },
    logs: {
      open: LogEvent.LIVECHAT_APP_OPEN_WEBPHONE,
      close: LogEvent.LIVECHAT_APP_CLOSE_WEBPHONE,
    },
  },
];
